import { C } from '../core/Element';
import FormSenderMailchimp from './FormSenderMailchimp';
import { FormValidator } from './FormValidator';

export default class FormsMailchimp {
  static init() {
    C.forEach('.__form-mailchimp', (e) => { new FormValidatorMailchimp(e); })
  }
}

export class FormValidatorMailchimp extends FormValidator {
  constructor(__form, __callback) {
    super(__form, __callback);
  }

  async send() {
    this._form.classList.add('--sending');

    await FormSenderMailchimp.sendMailchimp(this._dataSend)
      .then(status => this.callback(200))
      .catch(status => this.callback(status));
  }
}
